// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"AddAffiliateFrom_dropdown__1tCiR","phoneBorder":"AddAffiliateFrom_phoneBorder__3WmXr"};